import { useEntities } from "@hooks/useEntities";
import { formFieldsPlaygroundFields as fields } from "./formFieldsPlayground.schema";
import { StateRow } from "./FormFieldsPlaygroundStateRow";

/**
 * Every domain picker kit field in its normal, optional, tip, error and
 * disabled states. The tip column shows `multiple` where a field has it.
 * Pickers list the current workspace's accounts, payees and entities.
 */
export const FormFieldsPlaygroundPickerRows = () => {
    const ledgerEntityId = useEntities({ onlyBusiness: true })[0]?.id;

    return (
        <>
            <StateRow
                title="fields.FinancialAccount"
                cells={{
                    normal: (
                        <fields.FinancialAccount
                            name="financialAccount.normal"
                            label="Account"
                            hideArrow={false}
                        />
                    ),
                    optional: (
                        <fields.FinancialAccount
                            name="financialAccount.optional"
                            label="Deposit to"
                            optional
                            clearable
                            emptyValue={undefined}
                        />
                    ),
                    tip: (
                        <fields.FinancialAccount
                            name="financialAccount.tip"
                            label="Accounts"
                            description="Picks several"
                            multiple
                        />
                    ),
                    error: (
                        <fields.FinancialAccount
                            name="financialAccount.error"
                            label="Account"
                        />
                    ),
                    disabled: (
                        <fields.FinancialAccount
                            name="financialAccount.disabled"
                            label="Account"
                            disabled
                        />
                    ),
                }}
            />
            <StateRow
                title="fields.Counterparty"
                cells={{
                    normal: (
                        <fields.Counterparty
                            name="counterparty.normal"
                            label="Payee"
                        />
                    ),
                    optional: (
                        <fields.Counterparty
                            name="counterparty.optional"
                            label="Received from"
                            optional
                            clearable
                            emptyValue={null}
                        />
                    ),
                    tip: (
                        <fields.Counterparty
                            name="counterparty.tip"
                            label="Payees"
                            description="Picks several"
                            multiple
                        />
                    ),
                    error: (
                        <fields.Counterparty
                            name="counterparty.error"
                            label="Payee"
                        />
                    ),
                    disabled: (
                        <fields.Counterparty
                            name="counterparty.disabled"
                            label="Payee"
                            disabled
                        />
                    ),
                }}
            />
            {ledgerEntityId !== undefined && (
                <StateRow
                    title="fields.LedgerAccount"
                    cells={{
                        normal: (
                            <fields.LedgerAccount
                                name="ledgerAccount.normal"
                                label="Income account"
                                entityId={ledgerEntityId}
                            />
                        ),
                        optional: (
                            <fields.LedgerAccount
                                name="ledgerAccount.optional"
                                label="Receivables account"
                                entityId={ledgerEntityId}
                                optional
                                clearable
                                emptyValue={null}
                            />
                        ),
                        tip: (
                            <fields.LedgerAccount
                                name="ledgerAccount.tip"
                                label="Balancing account"
                                entityId={ledgerEntityId}
                                description="Accounts of the first business entity"
                            />
                        ),
                        error: (
                            <fields.LedgerAccount
                                name="ledgerAccount.error"
                                label="Income account"
                                entityId={ledgerEntityId}
                            />
                        ),
                        disabled: (
                            <fields.LedgerAccount
                                name="ledgerAccount.disabled"
                                label="Income account"
                                entityId={ledgerEntityId}
                                disabled
                            />
                        ),
                    }}
                />
            )}
            <StateRow
                title="fields.Entity"
                cells={{
                    normal: (
                        <fields.Entity name="entity.normal" label="Entities" />
                    ),
                    optional: (
                        <fields.Entity
                            name="entity.optional"
                            label="Entities"
                            optional
                        />
                    ),
                    tip: (
                        <fields.Entity
                            name="entity.tip"
                            label="Entities"
                            description="Business or personal, not both"
                            mutuallyExclusive
                        />
                    ),
                    error: (
                        <fields.Entity name="entity.error" label="Entities" />
                    ),
                    disabled: (
                        <fields.Entity
                            name="entity.disabled"
                            label="Entities"
                            disabled
                        />
                    ),
                }}
            />
        </>
    );
};
